import { Component, ViewChild, ViewContainerRef, AfterViewInit, inject } from '@angular/core';
import { ToasterService } from '@uigy/shared/components/toaster/services/toaster.service';


@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent implements AfterViewInit {
  private toasterService = inject(ToasterService);

  message: string = '';
  @ViewChild('NotificationBarWrapper', { read: ViewContainerRef }) container!: ViewContainerRef;

  ngAfterViewInit(): void {
    this.toasterService.bindContainer(this.container);
  }

}
